import {IComponentOptions, ILogService} from "angular";
import {StateParams, StateService} from "@uirouter/angularjs";
import {LoginDetails} from "../../model/LoginDetails";
import {AuthService} from "../auth.service";
import "./login.less";

class LoginController {
    public loginForm: any;
    public loginError: string;
    public nextUrl: string;
    public processing = false;
    public showErrors = false;
    public debug = false;
    public loginDetails = new LoginDetails();
    public options = {
        date: {
            date: true
        },
    };

    /* @ngInject */
    constructor(private $log: ILogService,
                private $state: StateService,
                private $stateParams: StateParams,
                private authService: AuthService,
                private toaster: any) {
    }

    public $onInit() {
        this.nextUrl = this.$stateParams["next"];
    }

    public onCleaveValueChange = (formattedValue) => {
        this.loginDetails.dateOfBirthFormatted = formattedValue;
    }

    public loginAsStaff() {

    }

    public loginAsProspectiveStudent() {
        this.processing = true;

        this.authService.loginProspectiveStudent(this.loginDetails)
            .then((user) => {
                this.$log.debug("successfully logged in as a prospective student");

                this.toaster.pop({type: "success", title: "Login successful. Redirecting ..."});

                this.$state.go("student.dashboard", {}, {reload: true}); 
            })
            .catch((error) => {
                if (error.data && error.data.isCurrentMonashStudent) {
                    this.toaster.pop({type: "failure", title: error.data.message});
                }

            })
            .finally(() => {
                    this.processing = false;
                }
            )
        ;
    }
}

export const LoginComponent: IComponentOptions = {
    controller: LoginController,
    template: require("./login.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/auth/login/login.component.ts